// extracted by mini-css-extract-plugin
export default {"group":"AreaGroup_group__9uXXB"};